import { App as CapacitorApp } from "@capacitor/app";

type UrlHandler = {
  id: string;
  handler: (url: URL) => Promise<void>;
};

class UrlHandlerService {
  private static instance: UrlHandlerService;
  private handlers: UrlHandler[] = [];
  private isListenerSet = false;

  private constructor() {
    this.setupListener();
  }

  public static getInstance(): UrlHandlerService {
    if (!UrlHandlerService.instance) {
      UrlHandlerService.instance = new UrlHandlerService();
    }
    return UrlHandlerService.instance;
  }

  private setupListener() {
    if (this.isListenerSet) return;

    CapacitorApp.addListener("appUrlOpen", async (event) => {
      const url = new URL(event.url);
      if (url.protocol === "name-alert:") {
        for (const { handler } of this.handlers) {
          await handler(url);
        }
      }
    });

    this.isListenerSet = true;
  }

  public registerHandler(id: string, handler: (url: URL) => Promise<void>) {
    this.handlers.push({ id, handler });
  }

  public removeHandler(id: string) {
    this.handlers = this.handlers.filter(h => h.id !== id);
  }
}

export default UrlHandlerService; 